const NUMBER_LOCALE = 'en-US' as const;

export function formatPromoNumber(value: number | null | undefined, maxFractionDigits = 20): string {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return Number(value).toLocaleString(NUMBER_LOCALE, {
    maximumFractionDigits: maxFractionDigits,
  });
}
